export default __webpack_public_path__ + "static/media/krzyzowka_4.d281a868.jpg";